module.exports = __webpack_public_path__ + "static/media/step.33189ab4.svg";